import StepConnector from '@material-ui/core/StepConnector';
import withStyles from '@material-ui/styles/withStyles';

import StepperLineIcon from 'assets/icons/stepper-line-icon.svg';

export const StyledStepConnector = withStyles(theme => ({
  completed: {
    '& $line': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  line: {
    height: 35,
    '-webkit-mask': `url(${StepperLineIcon}) center center / cover`,
    '-webkit-mask-size': '100% 100%',
    '-webkit-mask-repeat': 'no-repeat',
    backgroundColor: '#f9f9f9',
  },
}))(StepConnector);
